


















































import {
  computed,
  defineComponent,
  inject,
  onMounted,
  PropType,
  ref,
  toRefs,
  useContext,
  useStore
} from '@nuxtjs/composition-api'
import ServiceSearchHeaderFacetCassette from './components/ServiceSearchHeaderFacetCassette.vue'
import {
  useMouseDrug,
  useSlideFacet
} from '~/components/logics/search/service-search-header-facet-hooks'
import { serviceSearchOptionValue } from '~/stub/apigateway/master/master_pb'
import { ChangeConditionObject, ConditionOptionCommon } from '~/types/services/search'

const VISIBLE_FACET_COUNT = Object.freeze({
  PC: 7,
  SP: 3,
  TB: 6
})

const serviceSearchHeaderFacet = defineComponent({
  name: 'ServiceSearchHeaderFacet',
  components: {
    ServiceSearchHeaderFacetCassette
  },
  props: {
    conditionOption: {
      type: Object as PropType<ConditionOptionCommon>,
      default: () => ({})
    }
  },
  setup(props) {
    const store = useStore()
    const setOptionAttributes = inject<
      (condition: ChangeConditionObject, emitChangeEvent?: boolean) => void
    >('setOptionAttributes')
    const { $coconala } = useContext()
    const draggableContainerRef = ref<HTMLElement>()
    const { conditionOption } = toRefs(props)

    const isPC = computed<boolean>(() => {
      return store.getters['ui/isPC']
    })

    const isSP = computed<boolean>(() => {
      return store.getters['ui/isSP']
    })

    const {
      onMouseDownArea,
      onMouseMoveArea,
      resetMouseState,
      setContainer,
      isScrolling
    } = useMouseDrug()
    const {
      scrollLeftCassettes,
      scrollRightCassettes,
      onAttachedCassetteIntersect,
      showLeftScrollButton,
      showRightScrollButton,
      setItemRef
    } = useSlideFacet()

    // 画面内に表示される強調絞り込みの数
    const visibleItemCount = computed(() => {
      if (isPC.value) return VISIBLE_FACET_COUNT.PC
      if (isSP.value) return VISIBLE_FACET_COUNT.SP
      return VISIBLE_FACET_COUNT.TB
    })

    const isShowLeftScrollButton = computed(() => {
      if (conditionOption.value.master.valuesList.length < visibleItemCount.value) {
        return false
      }
      return showLeftScrollButton.value
    })

    const isShowRightScrollButton = computed(() => {
      if (conditionOption.value.master.valuesList.length < visibleItemCount.value) {
        return false
      }
      return showRightScrollButton.value
    })

    onMounted(() => {
      setContainer(document.querySelector('.js-druggableContainer'))
      setItemRef(
        draggableContainerRef.value,
        draggableContainerRef.value.getElementsByClassName('js-attachmentCassette')
      )
    })

    function changeCassette(value): void {
      setOptionAttributes({
        key: conditionOption.value.master.key,
        value,
        categoryId: conditionOption.value.option.relatedCategoryId
      })
    }

    function getIconUrl(
      key: string,
      serviceSearchOptionValue: serviceSearchOptionValue.AsObject
    ): string {
      const iconType = (() => {
        switch (key) {
          case 'master_category_type_id':
            return 'category_type_id'
          // TODO: category_v2 出品者ランクの強調絞り込みはなくなったのでprovider_levelsの指定は不要になるはず。確認後に削除する
          case 'provider_levels':
            return 'provider_levels'
          default:
            return 'facet_id'
        }
      })()
      const iconId = (() => {
        switch (key) {
          case 'master_category_type_id':
          case 'provider_levels':
            // TODO: category_v2 出品者ランクの強調絞り込みはなくなったのでprovider_levelsの指定は不要になるはず。確認後に削除する
            return serviceSearchOptionValue.value
          default:
            return serviceSearchOptionValue.id
        }
      })()
      return $coconala.fileURL(`/staticfiles/images/categories/facet/${iconType}_${iconId}.jpg`)
    }

    return {
      changeCassette,
      getIconUrl,
      // Drug
      draggableContainerRef,
      setContainer,
      onMouseDownArea,
      onMouseMoveArea,
      resetMouseState,
      isScrolling,
      // scroll
      scrollLeftCassettes,
      scrollRightCassettes,
      onAttachedCassetteIntersect,
      isShowLeftScrollButton,
      isShowRightScrollButton
    }
  }
})

export default serviceSearchHeaderFacet
